import TeacherCard from "./TeacherCard"
import "./TeacherCard.scss"

export default function TeacherModul(){

    const teachers = [
        {
            "name": "Ярослава Тимофієва",
            "about": "Керівниця центрів Смартум в м.Ізмаїл та Білгород-Дністровський",
            "img": "/t6.JPG"
        },
        {
            "name": "Ганна Бегунова",
            "about": "Тренер з Ментальної арифметики та Підготовки до школи",
            "img": "/tt1.jpg"
        },
        {
            "name": "Ганна Мітіна",
            "about": "Тренер з Англійської мови",
            "img": "/tt2.jpg"
        },
        {
            "name": "Анастасія Непота",
            "about": "Тренер з Англійської мови онлайн",
            "img": "/tt3.jpg"
        },
        {
            "name": "Ольга Волкова",
            "about": "Тренер з Ментальної арифметики в м.Ізмаїл",
            "img": "/tt5.jpg"
        },
        {
            "name": "Тетяна Руденко",
            "about": "Тренер з Ментальної арифметики та Спідкубінгу в м.Білгород-Дністровський та онлайн",
            "img": "/tt7.jpg"
        },
        {
            "name": "Анастасія Земляна-Українчук",
            "about": "Тренер з Англійської мови онлайн та в м.Білгород-Дністровський",
            "img": "/tt8.jpg"
        },
        {
            "name": "Тетяна Кравченко",
            "about": "Тренер з Підготовки до школи та Амаматики в м.Білгород-Дністровський та онлайн",
            "img": "/tt9.jpg"
        },
        {
            "name": "Світлана Парапір",
            "about": "Тренер з Ментальної арифметики, Підготовки до школи та Ліберики в м.Ізмаїл",
            "img": "/tt10.jpg"
        },
        {
            "name": "Тетяна Одуд",
            "about": "Тренер з Ментальної арифметики та Таблиці множення онлайн",
            "img": "/t4.jpg"
        },
    ]

    return(
        <div className="TeacherModule">
            {teachers.map((el) => {
                return <TeacherCard key={el.name} name={el.name} about = {el.about} img={el.img} />
            })}
        </div>
    )
}